import { CtResponse } from "../Fetch";
import { xget, xhttp } from "../Fetchv2";
import { Interview, InterviewAssignment, InterviewCompetency, InterviewQuestion } from "../schemas/mg.schema";

/**
 * @deprecated
 */
export class Interviewsv1 {
	// CREAR INTERVIEW
	async createInterview(interview: Interview): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp("/pages/interview", "POST", { interview });
		return response;
	}

	// OBTENER INTERVIEW
	async getInterview(id: number | string): Promise<CtResponse<any>> {
		let response = await xget(`/pages/interview/${id}`);
		return response;
	}

	// OBTENER TODOS LOS INTERVIEWS
	async getInterviews(pgid: string): Promise<CtResponse<any>> {
		let response = await xget(`/pages/interview/${pgid}/all`);
		return response;
	}

	// ACTUALIZAR INTERVIEW
	async updateInterview(interview: Interview): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/${interview._id}`, "PUT", { interview });
		return response;
	}

	// ACTUALIZAR PREGUNTA DE INTERVIEW
	async updateInterviewQuestion(id: number, questionId: string, question: InterviewQuestion): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/${id}/question/${questionId}`, "PUT", { question });
		return response;
	}

	// ACTUALIZAR PREGUNTAS DE LA ENTREVISTA
	async updateInterviewQuestions(id: number, questions: InterviewQuestion[]): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/${id}/questions`, "PUT", { questions });
		return response;
	}

	// AGREGAR PREGUNTA A INTERVIEW
	async addInterviewQuestion(id: number, question: InterviewQuestion): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/${id}/question`, "PUT", { question });
		return response;
	}

	// AGREGAR UNA COMPETENCIA A UNA PREGUNTA
	async addInterviewCompetency(id: number, competency: InterviewCompetency): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/${id}/competency`, "PUT", { competency });
		return response;
	}

	// AGREGAR ARRAY DE EMPLEOS A INTERVIEW
	async addInterviewJob(interId: number, jobs: { jobId: number; title: string }[]): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/${interId}/job`, "PUT", { jobs });
		return response;
	}

	// ELIMINAR INTERVIEW
	async deleteInterview(id: number): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/${id}`, "DELETE");
		return response;
	}

	// ELIMINAR PREGUNTA DE INTERVIEW
	async deleteInterviewQuestion(id: number, questionId: string): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/${id}/question/${questionId}`, "DELETE");
		return response;
	}

	// ELIMINAR UN TRABAJO DE INTERVIEW
	async deleteInterviewJob(id: number, jobId: string): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/${id}/job/${jobId}`, "DELETE");
		return response;
	}

	// ELIMINAR UNA COMPETENCIA
	async deleteInterviewCompetency(id: number, competencyId: string): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/${id}/competency/${competencyId}`, "DELETE");
		return response;
	}

	// == # ENTREVISTAS COMPLETAS # ===========================================================================================
	// GUARDAR ENTREVISTA COMPLETA
	// async saveInterviewCompleted(interview: InterviewCompleted): Promise<CtResponse<{ ok: number | undefined }>> {
	// 	let response = await xhttp(`/pages/interview/${interview._id}/completed`, "POST", { interview });
	// 	return response;
	// }

	// OBTENER TODAS LAS ENTREVISTAES COMPLETAS
	async getAllInterviewsCompleted(pgid: string): Promise<CtResponse<any>> {
		let response = await xget(`/pages/interview/${pgid}/completed/all`);
		return response;
	}

	// OBTENER TODAS LAS ENTREVISTAES COMPLETAS
	async getAllInterviewsCompletedSearch(pgid: string, search: string, value: string | number): Promise<CtResponse<any>> {
		// - value: INTERID | PGID | JOBID | USERID -
		let response = await xhttp(`/pages/interview/${pgid}/completed/search`, "SEARCH", { search, value });
		return response;
	}

	// OBTENER UNA ENTREVISTA COMPLETA
	async getInterviewCompleted(id: number | string): Promise<CtResponse<any>> {
		let response = await xget(`/pages/interview/${id}/completed`);
		return response;
	}

	// ACTUALIZAR ENTREVISTA COMPLETA
	// async updateInterviewCompleted(interview: InterviewCompleted): Promise<CtResponse<{ ok: number | undefined }>> {
	// 	let response = await xhttp(`/pages/interview/${interview._id}/completed`, "PUT", { interview });
	// 	return response;
	// }

	// ELIMINAR ENTREVISTA COMPLETA
	async deleteInterviewCompleted(id: number): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/${id}/completed`, "DELETE");
		return response;
	}

	// == # ASIGNACIONES DE ENTREVISTAS # ======================================================================================
	// CREAR ASIGNACION DE ENTREVISTA
	async createInterviewAssignment(assignment: InterviewAssignment): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/assignment`, "POST", { assignment });
		return response;
	}

	// OBTENER UNA ASIGNACION DE ENTREVISTA
	async getInterviewAssignment(id: number | string): Promise<CtResponse<any>> {
		let response = await xget(`/pages/interview/assignment/${id}`);
		return response;
	}

	// OBTENER TODAS LAS ASIGNACIONES DE ENTREVISTAS
	async getAllInterviewAssignments(pgid: string): Promise<CtResponse<any>> {
		let response = await xget(`/pages/interview/${pgid}/assignment/all`);
		return response;
	}

	// OBTENER TODAS LAS ASIGNACIONES DE ENTREVISTAS
	async getAllInterviewAssignmentsSearch(pgid: string, search: string, value: string | number): Promise<CtResponse<any>> {
		// - value: INTERID | PGID | JOBID | USERID | PROFILEID -
		let response = await xhttp(`/pages/interview/${pgid}/assignment/search`, "SEARCH", { search, value });
		return response;
	}

	// ACTUALIZAR ASIGNACION DE ENTREVISTA
	async updateInterviewAssignment(assignment: InterviewAssignment): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/assignment/${assignment._id}`, "PUT", { assignment });
		return response;
	}

	// ELIMINAR ASIGNACION DE ENTREVISTA
	async deleteInterviewAssignment(id: number): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/assignment/${id}`, "DELETE");
		return response;
	}

	// ENVIAR CORREO DE ASIGNACION DE ENTREVISTA
	async sendInterviewEmail(emails: string[], link: string): Promise<CtResponse<{ ok: number | undefined }>> {
		let response = await xhttp(`/pages/interview/email`, "POST", { emails, link });
		return response;
	}

	// == # PREGUNTAS DE ENTREVISTAS (SUGERIDAS) # =========================================================================================

	// OBTENER TODAS LAS PREGUNTAS DE ENTREVISTAS POR TEST
	async getSuggestedQuestionsByTestId(uid: string, pgid: string, tsId: string, score_array?: number[]): Promise<CtResponse<any>> {
		let response = await xhttp(`/pages/interview/${pgid}/suggested/${tsId}/questions/${uid}`, "SEARCH", { score_array });
		return response;
	}

	// OBTENER LAS PREGUNTAS INCLUIDAS
	async getSuggestedIncluded(uid: string, pgid: string, tsId: string): Promise<CtResponse<any>> {
		let response = await xget(`/pages/interview/${pgid}/included/${tsId}/questions/${uid}`);
		return response;
	}

	// OBTENER TODAS LAS ENTREVISTAS SUGERIDAS
	async getAllSuggestedInterview(pgid: string): Promise<CtResponse<any>> {
		let response = await xget(`/pages/interview/${pgid}/suggested/all`);
		return response;
	}

	// OBTIENE ENTREVISTA POR INTERVIEW.ID
	async getInterviewByInterId(pgid: string, tsId: string): Promise<CtResponse<any>> {
		let response = await xget(`/pages/interview/${pgid}/interid/${tsId}`);
		return response;
	}

	// OBTIENE ENTREVISTA POR RESULTADO DE TEST
	async getInterviewByTestResult(pgid: string, link: string): Promise<CtResponse<any>> {
		let response = await xget(`/pages/interview/${pgid}/testresult/${link}`);
		return response;
	}
}
